export default "__VITE_ASSET__C7iT_7z4__"